export enum SymbolNames {
    IBrowser = 'IBrowser',

    ICache = 'ICache',
    ICacheController = 'ICacheController',

    IConfigLog = 'IConfigLog',
    IConfigAPI = 'IConfigAPI',
    IConfigManifest = 'IConfigManifest',
    IConfigCache = 'IConfigCache',

    IEnv = 'IEnv',

    IFeatureQuery = 'IFeatureQuery',

    IFetch = 'IFetch',

    IKVStorage = 'IKVStorage',

    ILog = 'ILog',

    IMimeType = 'IMimeType',

    IProgressPromiseGenerator = 'IProgressPromiseGenerator',

    IQueryURL = 'IQueryURL',

    IRouter = 'IRouter',
    ITranslationStorage = 'ITranslationStorage',
    IZip = 'IZip',
}

const TYPES = {
    IBrowser: Symbol.for(SymbolNames.IBrowser),

    ICache: Symbol.for(SymbolNames.ICache),
    ICacheController: Symbol.for(SymbolNames.ICacheController),

    IConfigLog: Symbol.for(SymbolNames.IConfigLog),
    IConfigAPI: Symbol.for(SymbolNames.IConfigAPI),
    IConfigManifest: Symbol.for(SymbolNames.IConfigManifest),
    IConfigCache: Symbol.for(SymbolNames.IConfigCache),

    IEnv: Symbol.for(SymbolNames.IEnv),

    IFeatureQuery: Symbol.for(SymbolNames.IFeatureQuery),

    IFetch: Symbol.for(SymbolNames.IFetch),

    IKVStorage: Symbol.for(SymbolNames.IKVStorage),

    ILog: Symbol.for(SymbolNames.ILog),

    IMimeType: Symbol.for(SymbolNames.IMimeType),

    IProgressPromiseGenerator: Symbol.for(SymbolNames.IProgressPromiseGenerator),

    IQueryURL: Symbol.for(SymbolNames.IQueryURL),

    IRouter: Symbol.for(SymbolNames.IRouter),
    ITranslationStorage: Symbol.for(SymbolNames.ITranslationStorage),
    IZip: Symbol.for(SymbolNames.IZip),
} as const;

export default TYPES;
